import { clearTag, downloadTag } from "api/tags";
import { downloadExp } from "api/expression";
import { getAllDataSources } from "api/dataSourceMeta";

const actionApiConfig = {
  downloadTag,
  downloadExp,
  clearTag,
  getAllDataSources
};

export default actionApiConfig;